<proffeo-ui-dialog [title]="'cooperations.modals.create-title' | translate">
  <div class="flex flex-col w-full h-full gap-4">
    <div class="flex flex-col w-full gap-4">
      <div class="flex w-full flex-col gap-2">
        <p class="pl-1 text-sm">
          {{ 'cooperations.modals.form-label-description' | translate }}
          <span class="text-proffeo-danger">*</span>
        </p>
        <proffeo-ui-textarea
          [formField]="form.description"
          [autosize]="false"
          [rows]="4"
          [resizable]="false"
          class="w-full"
        >
          @if (descriptionTooLong()) {
            <p proffeoUiTextareaError>
              {{ 'errors.maxlength' | translate: { requiredLength: maxDescriptionLength } }}
            </p>
          }
        </proffeo-ui-textarea>
      </div>

      <div class="flex w-full flex-col gap-2">
        <p class="pl-1 text-sm">
          {{ 'cooperations.modals.form-label-recipient-company' | translate }}
          <span class="text-proffeo-danger">*</span>
        </p>
        <proffeo-select-company-list
          [(selectedCompanyId)]="selectedCompanyId"
          [companies]="data.companies"
        ></proffeo-select-company-list>
      </div>
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      [text]="'close' | translate"
      variant="primary"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="!canSave()"
      [text]="'save-and-close' | translate"
      variant="accent"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
